import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const SideLiteTypeEticom = ({ value, onChange, label = 'Side Lite Type', disabled = false }) => {
    const defaultValue = value || 'All Glass';
    const [selectedSideLiteTypeEticom, setSelectedSideLiteTypeEticom] = useState(defaultValue);

    // Call onChange once on mount if value is not provided
    useEffect(() => {
        if (!value) {
            onChange(defaultValue);
        }
    }, []); // empty deps to run only once


    const handleSideLiteTypeEticomChange = (e) => {
        const newValue = e.target.value;
        setSelectedSideLiteTypeEticom(newValue);
        onChange(newValue);

    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor="SideLiteTypeEticom">{label}</label>
            <select
                disabled={disabled}
                id="SideLiteTypeEticom"
                value={selectedSideLiteTypeEticom}
                onChange={handleSideLiteTypeEticomChange}
            >
                <option value="" disabled hidden>Select an option</option>
                <option value='All Glass'>{selectedSideLiteTypeEticom === 'All Glass' ? 'All Glass ✔' : 'All Glass'}</option>
            </select>
        </div>
    );
};

export default SideLiteTypeEticom;
